import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const setWebsiteClaim = httpsCallable(functions, 'setWebsiteClaim');
export const disableEmployeeLoginCallable = httpsCallable(functions, 'disableEmployeeLogin');

// This handles setting the token on the auth user with the website id so we know to relate them to that website.
export const callSetWebsiteClaim = async (userId: string, accessCode: string) => {
    try {
        return await setWebsiteClaim({ userId, accessCode });
    } catch (error) {
        console.error('Error calling function:', error);
        return { status: 404, message: 'failed to add website claim' }
    }
};

export const callDisableEmployeeLogin = async (siteId: string, employeeId: string) => {
    try {
        return await disableEmployeeLoginCallable({ siteId, employeeId });
    } catch (error) {
        console.error('Error calling disableEmployeeLogin:', error);
        throw error;
    }
};
